export const modeMap = {
  'draft-requisitions': 'draft',
  'open-requisitions': 'open',
  'closed-requisitions': 'closed',
};

export const getDateSort = (mode) => (mode === 'open' ? '-opened_at' : '-closed_at');
export const getDefaultReqSort = (mode) => ({
  open: '-opened_at',
  closed: '-closed_at',
  draft: 'ats_requisition_label',
}[mode] || getDateSort(mode));
